import React, { useState, useEffect } from "react";

import { Container, Row, Col, Form } from "react-bootstrap";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import makeAnimated from "react-select/animated";
import { checkPermissionStatus } from "helpers/utils";
import { getAllSkills, getRoundsData } from "services/commonService";
import { ReactSortable } from "react-sortablejs";
import {
  faArrowAltCircleRight,
  faExclamation,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Spinner } from "reactstrap";
import { isEmpty } from "lodash";
import {
  fetchinterViewers,
  generateDescriptionHelper,
} from "helpers/backend_helper";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import { getUserInfo } from "helpers/authHelper";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import api from "../../api";
import { Tooltip } from "react-tooltip";

const animatedComponents = makeAnimated();

const CreateJob = props => {
  const history = useHistory();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [vtypes, setVType] = useState([]);
  const [statePayload, setStatePayload] = useState({
    number_of_openings: 0,
    status: "1",
    location_mapped_with: "city",
  });
  const [City, setCity] = useState([]);
  const [allCityLocations, setAllCityLocations] = useState([]);
  const [FranchiseList, setFranchiseList] = useState([]);
  const [allFranchiseLocations, setAllFranchiseLocations] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [company, setCompany] = useState([]);
  const [roundList, setRoundList] = useState([]);
  const [selectedRounds, setSelectedRounds] = useState([]);
  const [contentLoading, setContentLoading] = useState(false);
  const [allSkills, setAllSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [interviewerList, setInterviewerList] = useState([]);

  const companyCurrency = getUserInfo()?.company_currency || {};

  const expectedTimeOptions = [
    { label: "Part-Time", value: "Part-Time" },
    { label: "Full-Time", value: "Full-Time" },
    { label: "Contract", value: "Contract" },
    { label: "Freelance", value: "Freelance" },
    { label: "Temporary", value: "Temporary" },
  ];

  const interviewTypes = [
    { label: "Offline", value: "0" },
    { label: "Online", value: "1" },
  ];

  const handleInput = event => {
    const { name, value } = event.target;

    setStatePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCompanySelection = companyID => {
    setStatePayload(prevState => ({
      ...prevState,
      company_id: companyID,
    }));
  };

  const handleVtypeSelection = vacancyID => {
    setStatePayload(prevState => ({
      ...prevState,
      vacancy_type_id: vacancyID,
    }));
  };

  const createNewJob = async payload => {
    await api
      .post(
        `${process.env.REACT_APP_API_URL}/admin/job/create-job`,
        payload,
        {}
      )
      .then(response => {
        setIsLoading(false);
        toast.success("Job created successfully");
        history.push("/job-list");
      })
      .catch(err => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message || "Something Went Wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);
    let errorObj = {};

    if (isEmpty(statePayload?.title)) {
      errorObj = {
        ...errorObj,
        title: "Title is Required!",
      };
    }
    if (isEmpty(statePayload?.vacancy_type_id)) {
      errorObj = {
        ...errorObj,
        vacancy_type_id: "Position Level is Required!",
      };
    }
    if (
      ["franchise"].includes(statePayload?.location_mapped_with?.toLowerCase())
    ) {
      if (!statePayload?.franchise_id) {
        errorObj = {
          ...errorObj,
          franchise_id: "Franchise is Required!",
        };
      }
    } else {
      if (isEmpty(statePayload?.city_id)) {
        errorObj = {
          ...errorObj,
          city_id: "City is Required!",
        };
      }
    }
    if (isEmpty(statePayload?.department_id)) {
      errorObj = {
        ...errorObj,
        department_id: "Department is Required!",
      };
    }
    if (isEmpty(statePayload?.mode_of_job)) {
      errorObj = {
        ...errorObj,
        mode_of_job: "Mode of Job is Required!",
      };
    }
    if (isEmpty(statePayload?.number_of_jobs)) {
      errorObj = {
        ...errorObj,
        number_of_jobs: "Number of Vacancies is Required!",
      };
    }
    if (isEmpty(statePayload?.qualification)) {
      errorObj = {
        ...errorObj,
        qualification: "Qualification is Required!",
      };
    }
    if (isEmpty(statePayload?.experience)) {
      errorObj = {
        ...errorObj,
        experience: "Experience is Required!",
      };
    }
    if (selectedRounds?.length === 0) {
      errorObj = {
        ...errorObj,
        roundList: "Round List is Required!",
      };
    }
    if (
      selectedRounds?.length > 0 &&
      selectedRounds?.filter(
        el => el?.type === "Interview" && !el?.interviewer_id
      )?.length > 0
    ) {
      errorObj = {
        ...errorObj,
        roundList: "Please Select Interviewers for Interview Rounds",
      };
    }
    if (
      selectedRounds?.length > 0 &&
      selectedRounds?.filter(
        el => el?.type === "Interview" && !el?.meeting_type
      )?.length > 0
    ) {
      errorObj = {
        ...errorObj,
        roundList: "Please Select Interview Type for Interview Rounds",
      };
    }
    if (isEmpty(statePayload?.status)) {
      errorObj = {
        ...errorObj,
        status: "Status is Required!",
      };
    }
    if (isEmpty(statePayload?.description)) {
      errorObj = {
        ...errorObj,
        description: "Job Description is Required!",
      };
    }
    if (isEmpty(selectedSkills)) {
      errorObj = {
        ...errorObj,
        skills: "Skills are Required!",
      };
    }
    if (isEmpty(statePayload?.expected_time)) {
      errorObj = {
        ...errorObj,
        expected_time: "Expected Time is Required!",
      };
    }
    if (isEmpty(statePayload?.min_salary)) {
      errorObj = {
        ...errorObj,
        min_salary: "This Field is Required!",
      };
    }
    if (isEmpty(statePayload?.max_salary)) {
      errorObj = {
        ...errorObj,
        max_salary: "This Field is Required!",
      };
    }

    if (isEmpty(statePayload?.relevance_score)) {
      errorObj = {
        ...errorObj,
        relevance_score: "This Field is Required!",
      };
    }

    if (isEmpty(statePayload?.video_analysis_score)) {
      errorObj = {
        ...errorObj,
        video_analysis_score: "This Field is Required!",
      };
    }

    if (isEmpty(statePayload?.video_analysis_ques)) {
      errorObj = {
        ...errorObj,
        video_analysis_ques: "This Field is Required!",
      };
    }

    // Setting the error object if any errors are present;
    if (Object.keys(errorObj)?.length > 0) {
      setErrors(errorObj);
      setIsLoading(false);
      return false;
    }

    let round_list = selectedRounds?.map(el => el?.value) || [];

    let skillIds =
      selectedSkills?.filter(skill => !!skill?.id)?.map(skill => skill?.id) ||
      [];
    let createdSkills =
      selectedSkills?.filter(skill => !skill?.id)?.map(skill => skill?.label) ||
      [];

    let company_id;

    if (statePayload?.company_id == undefined) {
      company_id = localStorage.getItem("subdomainId");
    } else {
      company_id = statePayload?.company_id;
    }

    let payload = {
      title: statePayload?.title,
      description: statePayload?.description,
      qualification: statePayload?.qualification,
      skillIds: JSON.stringify(skillIds),
      createdSkills: JSON.stringify(createdSkills),
      experience: statePayload?.experience,
      vacancy_type_id: statePayload?.vacancy_type_id,
      expected_time: statePayload?.expected_time,
      status: statePayload?.status,
      license: statePayload?.license,
      location_mapped_with: statePayload?.location_mapped_with || "city",
      city_id: statePayload?.city_id?.join(","),
      location_id: selectedCityLocations?.map(location => ({
        location_id: location?.id,
        country_id: location?.country_id,
        region_id: location?.region_id,
        state_id: location?.state_id,
        city_id: location?.city_id,
      })),
      franchise_id: statePayload?.franchise_id,
      franchise_location_id: selectedFranchiseLocations?.map(loc => ({
        location_id: loc?.id,
        country_id: loc?.country_id,
        region_id: loc?.region_id,
        state_id: loc?.state_id,
        city_id: loc?.city_id,
      })),
      department_id: selectedDepts?.map(dept => dept?.id),
      mode_of_job: statePayload?.mode_of_job,
      number_of_jobs: statePayload?.number_of_jobs,
      number_of_openings: statePayload?.number_of_openings,
      min_salary: statePayload?.min_salary,
      max_salary: statePayload?.max_salary,
      relevance_score: statePayload?.relevance_score,
      video_analysis_score: statePayload?.video_analysis_score,
      video_analysis_ques: statePayload?.video_analysis_ques,
      round_list: JSON.stringify(round_list),
      company_id: company_id,
      interviewerRoundsData: selectedRounds,
    };

    payload = encryptDataToArray(payload);

    // Calling the api and saving data;
    await createNewJob({
      query: payload,
    });
  };

  const fetchVacancyTypeData = () => {
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/vacancyType/fetch-vacancytype`
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        const { success, allVacType } = responseData || {};

        if (success) {
          let data = allVacType?.map(item => ({
            id: item?.id,
            label: item?.title,
            value: item?.vacancy_name,
          }));
          setVType(data);
        }
      })
      .catch(err => {});
  };

  const fetchCityData = () => {
    let language = localStorage.getItem("lang_id");
    api
      .get(
        `${process.env.REACT_APP_API_URL}/getcity/city-listing?language_id=${language}`,
      )
      .then(response => {
        const allCity = response.data.cities;
        let data = allCity?.map(item => ({
          id: item?.id,
          label: item?.city,
          value: item?.city,
        }));
        setCity(data);
      })
      .catch(err => {});
  };

  const fetchAllCityLocations = () => {
    let language = localStorage.getItem("lang_id");
    api
      .get(
        `${process.env.REACT_APP_API_URL}/getcity/location-listing?language_id=${language}`
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        let allCityLocations = responseData?.allLocations || [];
        let groupedData = allCityLocations?.reduce((prev, curr) => {
          let currCity = curr?.city;
          let currCityOptions = prev?.[currCity]?.options || [];
          currCityOptions.push(curr);
          prev[currCity] = {
            label: currCity,
            options: currCityOptions,
          };

          return prev;
        }, {});
        groupedData = Object.values(groupedData);

        setAllCityLocations(groupedData);
      })
      .catch(err => {});
  };

  const fetchAllFranchiseWithLocations = () => {
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/Franchise/list-with-location`,
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        let FranchiseList = responseData?.data || [];

        setFranchiseList(FranchiseList);
        setAllFranchiseLocations([]);
      })
      .catch(err => {});
  };

  const fetchAllDepartments = async () => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/admin/job/all-departments`, {
      })
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);
        let allDepartments = responseData?.data?.allDepartments || [];
        setAllDepartments(allDepartments);
      })
      .catch(err => {
        setAllDepartments([]);
      });
  };

  const fetchRoundsData = async () => {
    await getRoundsData()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setRoundList(responseData?.data);
        } else {
          toast.error("No data available");
          setRoundList([]);
        }
      })
      .catch(err => {
        toast.error("No data Available");
        setRoundList([]);
      });
  };

  const fetchCompanyData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/company/fetch-company`)
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        const { success, allCompany } = responseData || {};

        if (success) {
          let data = allCompany?.map(item => ({
            id: item?.id,
            label: item?.company_name,
            value: item?.id,
          }));
          setCompany(data);
        }
      })
      .catch(err => {});
  };

  const fetchAllSkills = async () => {
    await getAllSkills()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        let allSkills = responseData?.data?.companySkills || [];
        allSkills = allSkills?.map(skill => ({
          value: skill?.id,
          label: skill?.name,
          ...skill,
        }));
        setAllSkills(allSkills);
      })
      .catch(err => {
        toast.error("No skills Available");
        setAllSkills([]);
      });
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  useEffect(() => {
    fetchVacancyTypeData();
    fetchCityData();
    fetchAllCityLocations();
    fetchAllFranchiseWithLocations();
    fetchAllDepartments();
    fetchCompanyData();
    fetchRoundsData();
    fetchAllSkills();
    getInterviewerList();

    return () => {};
  }, []);

  const getInterviewerList = async () => {
    await fetchinterViewers()
      .then(res => {
        let { userList, success } = decryptDataFromArray(res);
        let data = userList?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.id,
        }));
        setInterviewerList(data);
      })
      .catch(err => {});
  };

  const [selectedModeOfJob, setSelectedModeOfJob] = useState(null);
  const handleSelectMode = selectedModeOfJob => {
    setSelectedModeOfJob(selectedModeOfJob);
    setStatePayload(prevState => ({
      ...prevState,
      mode_of_job: selectedModeOfJob?.value,
    }));
  };

  const [selectedNumberOfJobsOption, setSelectedNumberOfJobOptions] =
    useState(null);
  const handleNumberOfJobs = selectedNumberOfJobsOption => {
    setSelectedNumberOfJobOptions(selectedNumberOfJobsOption);
    setStatePayload(prevState => ({
      ...prevState,
      number_of_jobs: selectedNumberOfJobsOption?.value,
    }));
  };

  const [selectedCities, setSelectedCities] = useState([]);
  const handleSelectAllCities = () => {
    setSelectedCities(City);
    const allCityValues = City?.map(city => city.id);
    setStatePayload(prevState => ({
      ...prevState,
      city_id: allCityValues,
    }));
  };

  const handleDeselectAllCities = () => {
    setSelectedCities([]);
    setSelectedCityLocations([]);

    setStatePayload(prevState => ({
      ...prevState,
      city_id: [],
      location_id: [],
    }));
  };

  const handleChangeCity = selectedCities => {
    if (!selectedCities?.length) {
      handleDeselectAllCities();

      return;
    }

    setSelectedCities(selectedCities);
    const allCityValues = selectedCities?.map(city => city.id);

    let tempLocations = selectedCityLocations?.filter(location =>
      selectedCities?.some(opt => opt?.label === location?.city)
    );
    setSelectedCityLocations(tempLocations);
    let allLocationValues = tempLocations?.map(location => location?.id);

    setStatePayload(prevState => ({
      ...prevState,
      city_id: allCityValues,
      location_id: allLocationValues,
    }));
  };

  const [selectedCityLocations, setSelectedCityLocations] = useState([]);
  const handleSelectAllCityLocations = () => {
    if (!selectedCities?.length) {
      handleDeselectAllCityLocations();

      return;
    }

    let tempLocations = allCityLocations?.filter(location =>
      selectedCities?.some(opt => opt?.label === location?.label)
    );

    setSelectedCityLocations(
      tempLocations?.reduce(
        (prev, curr) => [...prev, ...(curr?.options || [])],
        []
      )
    );
    let allLocationValues = tempLocations?.reduce(
      (prev, curr) => [...prev, ...curr?.options?.map(c => c?.id)],
      []
    );
    setStatePayload(prevState => ({
      ...prevState,
      location_id: allLocationValues,
    }));
  };

  const handleDeselectAllCityLocations = () => {
    setSelectedCityLocations([]);
    setStatePayload(prevState => ({
      ...prevState,
      location_id: [],
    }));
  };

  const handleChangeCityLocation = options => {
    setSelectedCityLocations(options);
    let locationValues = options?.map(location => location?.id);
    setStatePayload(prevState => ({
      ...prevState,
      location_id: locationValues,
    }));
  };

  const [selectedFranchiseLocations, setSelectedFranchiseLocations] = useState(
    []
  );
  const handleSelectAllFranchiseLocations = () => {
    if (!statePayload?.franchise_id) {
      handleDeselectAllFranchiseLocations();

      return;
    }

    setSelectedFranchiseLocations(allFranchiseLocations);
    let allLocationValues = allFranchiseLocations?.map(loc => loc?.id);

    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: allLocationValues,
    }));
  };

  const handleDeselectAllFranchiseLocations = () => {
    setSelectedFranchiseLocations([]);
    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: [],
    }));
  };

  const handleChangeFranchiseLocation = options => {
    setSelectedFranchiseLocations(options);

    let locationValues = options?.map(location => location?.id);
    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: locationValues,
    }));
  };

  const [selectedDepts, setSelectedDepts] = useState([]);

  const handleSelectAllDepts = () => {
    setSelectedDepts(allDepartments);

    let allDeptValues = allDepartments?.map(dept => dept?.id);

    setStatePayload(prevState => ({
      ...prevState,
      department_id: allDeptValues,
    }));
  };

  const handleDeselectAllDepts = () => {
    setSelectedDepts([]);

    setStatePayload(prevState => ({
      ...prevState,
      department_id: [],
    }));
  };

  const handleChangeDept = (options = []) => {
    setSelectedDepts(options || []);

    let allDeptValues = options?.map(dept => dept?.id) || [];

    setStatePayload(prevState => ({
      ...prevState,
      department_id: allDeptValues,
    }));
  };

  const handleAddRound = roundItem => {
    let roundsList = [...roundList];
    roundsList = roundsList?.filter(el => el?.value !== roundItem?.value);
    let selectedList = [...selectedRounds];
    if (roundItem?.alias === "pre-assessment") {
      selectedList.unshift({ ...roundItem });
    } else {
      selectedList.push({ ...roundItem });
    }
    setSelectedRounds(selectedList);
    setRoundList(roundsList);
  };

  const handleRemoveRound = roundItem => {
    let roundsList = [...roundList];
    roundsList.push({ ...roundItem });
    let selectedList = [...selectedRounds];
    selectedList = selectedList?.filter(el => el?.value !== roundItem?.value);
    setSelectedRounds(selectedList);
    setRoundList(roundsList);
  };

  // Appending buttons to the options list
  const extendedCityOptions = [
    {
      value: "buttons",
      label: (
        <div className="d-flex gap-2">
          <button className="selectall-btn" onClick={handleSelectAllCities}>
            Select All
          </button>
          <button className="selectall-btn" onClick={handleDeselectAllCities}>
            Deselect All
          </button>
        </div>
      ),
      isDisabled: true,
    },
    ...City,
  ];

  const extendedCityLocationOptions = [
    {
      value: "buttons",
      label: (
        <div className="d-flex gap-2">
          <button
            className="selectall-btn"
            onClick={handleSelectAllCityLocations}
          >
            Select All
          </button>
          <button
            className="selectall-btn"
            onClick={handleDeselectAllCityLocations}
          >
            Deselect All
          </button>
        </div>
      ),
      isDisabled: true,
    },
    ...allCityLocations?.filter(location =>
      selectedCities?.some(opt => opt?.label === location?.label)
    ),
  ];

  const extendedFranchiseLocationOptions = [
    {
      value: "buttons",
      label: (
        <div className="d-flex gap-2">
          <button
            className="selectall-btn"
            onClick={handleSelectAllFranchiseLocations}
          >
            Select All
          </button>
          <button
            className="selectall-btn"
            onClick={handleDeselectAllFranchiseLocations}
          >
            Deselect All
          </button>
        </div>
      ),
      isDisabled: true,
    },
    ...allFranchiseLocations,
  ];

  const extendedDeptOptions = [
    {
      value: "buttons",
      label: (
        <div className="d-flex gap-2">
          <button className="selectall-btn" onClick={handleSelectAllDepts}>
            Select All
          </button>
          <button className="selectall-btn" onClick={handleDeselectAllDepts}>
            Deselect All
          </button>
        </div>
      ),
      isDisabled: true,
    },
    ...allDepartments,
  ];

  const extendedOptions1 = [
    {
      value: "Onsite",
      label: "Onsite",
    },
    {
      value: "Hybrid",
      label: "Hybrid",
    },
    {
      value: "Remote",
      label: "Remote",
    },
  ];
  const extendedOptions2 = [
    {
      value: "Limited",
      label: "Limited",
    },
    {
      value: "Evergreen",
      label: "Evergreen",
    },
  ];

  if (!checkPermissionStatus("job-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  const handleContentGeneration = async () => {
    setContentLoading(true);
    let errorObj = {};
    if (isEmpty(statePayload?.title)) {
      errorObj = {
        ...errorObj,
        title: "Title is Required!",
      };
    }
    if (isEmpty(statePayload?.vacancy_type_id)) {
      errorObj = {
        ...errorObj,
        vacancy_type_id: "Position Level is Required!",
      };
    }
    if (statePayload?.location_mapped_with === "franchise") {
      if (!statePayload?.franchise_id) {
        errorObj = {
          ...errorObj,
          franchise_id: "Franchise is Required!",
        };
      }
    } else {
      if (isEmpty(statePayload?.city_id)) {
        errorObj = {
          ...errorObj,
          city_id: "City is Required!",
        };
      }
    }
    if (isEmpty(statePayload?.department_id)) {
      errorObj = {
        ...errorObj,
        department_id: "Department is Required!",
      };
    }
    if (isEmpty(statePayload?.mode_of_job)) {
      errorObj = {
        ...errorObj,
        mode_of_job: "Mode of Job is Required!",
      };
    }
    if (isEmpty(statePayload?.number_of_jobs)) {
      errorObj = {
        ...errorObj,
        number_of_jobs: "Number of Vacancies is Required!",
      };
    }
    // if (isEmpty(statePayload?.number_of_openings)) {
    //   errorObj = {
    //     ...errorObj,
    //     number_of_jobs: "Number of openings is Required!",
    //   };
    // }
    if (isEmpty(statePayload?.qualification)) {
      errorObj = {
        ...errorObj,
        qualification: "Qualification is Required!",
      };
    }
    if (isEmpty(statePayload?.experience)) {
      errorObj = {
        ...errorObj,
        experience: "Experience is Required!",
      };
    }
    if (isEmpty(selectedSkills)) {
      errorObj = {
        ...errorObj,
        skills: "Skills are Required!",
      };
    }
    if (isEmpty(statePayload?.expected_time)) {
      errorObj = {
        ...errorObj,
        expected_time: "Expected Time is Required!",
      };
    }

    if (Object.keys(errorObj)?.length > 0) {
      setErrors(errorObj);
      setContentLoading(false);
      toast.error("Please fill required fields!");
      return false;
    }

    let skills = selectedSkills?.map(skill => skill?.label)?.join(",");
    let cities = selectedCities?.map(el => el?.label)?.join(",");
    let departments = selectedDepts?.map(dept => dept?.label)?.join(",");

    let descriptionPrompt = `Generate HTML Page Job application details with description for ${statePayload?.title} having the skills ${skills} with Position - ${statePayload?.title}, Experience - ${statePayload?.experience}, Location - ${cities}, Expected Time - ${statePayload?.expected_time}, Qualification - ${statePayload?.qualification}, Department - ${departments}`;

    let encryptedQuery = encryptDataToArray(descriptionPrompt);

    let payload = {
      prompt: encryptedQuery,
    };
    let resp = await generateDescriptionHelper(payload)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        let content = responseData?.description || "";

        setStatePayload(prevState => ({
          ...prevState,
          ["description"]: content,
        }));

        toast.success("Description Generated Successfully.");
        setContentLoading(false);
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          err?.message ||
          "Error while generating description";

        setContentLoading(false);
        toast.error(errMsg);
      });
  };

  const handleSelectInterviewer = (e, ind) => {
    let selectRounds = selectedRounds;
    selectRounds[ind].interviewer_id = e?.value;
    setSelectedRounds(selectRounds);
  };

  const handleSelectInterviewType = (e, ind) => {
    let selectRounds = selectedRounds;
    selectRounds[ind].meeting_type = e?.value;
    setSelectedRounds(selectRounds);
  };

  const handleScoreThreshold = (e, ind) => {
    let selectRounds = selectedRounds;
    selectRounds[ind].score_threshold = e;
    setSelectedRounds(selectRounds);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/job-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Create Job
                </h5>
              </Link>
            </Col>

            {/* <Col lg="6" md="6">
              <div class="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/vacancyType-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>
        {/* <Row className="mb-3 align-items-center border-bottom py-2 pt-0">
          <Col lg="6" md="6">
            <h5 className="text-uppercase heading-one pt-1">Create Job</h5>
          </Col>

          <Col lg="6" md="6">
            <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
              <Link to="/job-list" className="btn btn-primary">
                Back To Listing
              </Link>
            </div>
          </Col>
        </Row> */}

        {/* <div className="personal-heading pb-2">
          <h2 className="heading-two">Job Details:</h2>
        </div> */}

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section jobdetails">
            <Row>
              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Job Title<span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Job Title"
                  name="title"
                  value={statePayload?.title}
                  onChange={handleInput}
                />
                {errors?.title && (
                  <p className="text-danger"> {errors?.title} </p>
                )}
              </Form.Group>

              {localStorage.getItem("subdomainId") === "" && (
                <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                  <Form.Label className="float-label">
                    Company<span class="text-danger">*</span>
                  </Form.Label>
                  <select
                    name="company_id"
                    className="col-md-6 mb-1 form-control form-select"
                    style={{ width: "100%" }}
                    onChange={e => handleCompanySelection(e.target.value)}
                  >
                    {localStorage.getItem("subdomainId") === "" &&
                      company &&
                      company?.map(el => (
                        <option key={el.value} value={el.id}>
                          {el.label}
                        </option>
                      ))}
                  </select>

                  {errors?.role_id && (
                    <p className="text-danger">{errors?.role_id}</p>
                  )}
                </Form.Group>
              )}

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Position Level<span class="text-danger">*</span>
                </Form.Label>
                <select
                  type="select"
                  name="saas_parent"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={e => handleVtypeSelection(e.target?.value)}
                >
                  <option value="" selected>
                    Select Position Level
                  </option>
                  {vtypes &&
                    vtypes?.map(el => {
                      return (
                        <option key={el?.value} value={el?.id}>
                          {el?.label}
                        </option>
                      );
                    })}
                </select>
                {errors?.vacancy_type_id && (
                  <p className="text-danger"> {errors?.vacancy_type_id} </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Mode Of Job<span class="text-danger">*</span>
                </Form.Label>
                <div className="selectoption">
                  <Select
                    options={extendedOptions1}
                    value={selectedModeOfJob}
                    onChange={handleSelectMode}
                  />{" "}
                </div>
                {errors?.mode_of_job && (
                  <p className="text-danger"> {errors?.mode_of_job} </p>
                )}
              </Form.Group>
              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Number Of Vacancies<span class="text-danger">*</span>
                </Form.Label>
                <div className="selectoption">
                  <Select
                    options={extendedOptions2}
                    value={selectedNumberOfJobsOption}
                    onChange={handleNumberOfJobs}
                  />{" "}
                </div>
                {errors?.number_of_jobs && (
                  <p className="text-danger"> {errors?.number_of_jobs} </p>
                )}
              </Form.Group>

              {selectedNumberOfJobsOption?.value === "Limited" && (
                <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                  <Form.Label className="float-label">
                    Number Of Openings<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Number Of Openings"
                    name="number_of_openings"
                    value={statePayload?.number_of_openings}
                    onChange={handleInput}
                  />
                  {errors?.number_of_openings && (
                    <p className="text-danger">
                      {" "}
                      {errors?.number_of_openings}{" "}
                    </p>
                  )}
                </Form.Group>
              )}

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Department<span class="text-danger">*</span>
                </Form.Label>
                <div className="selectoption">
                  <Select
                    isMulti
                    options={extendedDeptOptions}
                    value={selectedDepts}
                    onChange={handleChangeDept}
                  />
                </div>
                {errors?.department_id && (
                  <p className="text-danger"> {errors?.department_id} </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Required Qualification<span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Required Qualification "
                  name="qualification"
                  value={statePayload?.qualification}
                  onChange={handleInput}
                />
                {errors?.qualification && (
                  <p className="text-danger"> {errors?.qualification} </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Required Experience<span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Required Experience "
                  name="experience"
                  value={statePayload?.experience}
                  onChange={handleInput}
                />
                {errors?.experience && (
                  <p className="text-danger"> {errors?.experience} </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Required Expected Time<span class="text-danger">*</span>
                </Form.Label>
                <Select
                  options={expectedTimeOptions}
                  value={
                    expectedTimeOptions?.find(
                      el => el?.value === statePayload?.expected_time
                    ) || ""
                  }
                  onChange={e => {
                    setStatePayload(prevState => ({
                      ...prevState,
                      expected_time: e?.value,
                    }));
                  }}
                />
                {errors?.expected_time && (
                  <p className="text-danger"> {errors?.expected_time} </p>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label  required-skill-card">
                <Form.Label className="float-label">
                  Required Skills<span class="text-danger">*</span>
                </Form.Label>

                <div className="selectoption">
                  <CreatableSelect
                    placeholder={`Select skills required for the job`}
                    isClearable
                    isMulti
                    value={selectedSkills}
                    options={allSkills}
                    onChange={e => {
                      let selectedSkills = e?.map(skill => ({
                        ...skill,
                        value:
                          typeof skill?.value === "string"
                            ? skill?.value?.trim()
                            : skill?.value,
                        label: skill?.label?.trim(),
                      }));
                      setSelectedSkills(selectedSkills);
                    }}
                    closeMenuOnSelect={false}
                    // components={animatedComponents}
                  />
                </div>

                {errors?.skills && (
                  <p className="text-danger"> {errors?.skills} </p>
                )}
              </Form.Group>

              <Col md={12}>
                <Row>
                  <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                    <Form.Label className="float-label">
                      Job Mapping With
                    </Form.Label>

                    <Form.Check
                      type="radio"
                      id="option1"
                      name="location_mapped_with"
                      value="city"
                      label="City"
                      checked={["city"].includes(
                        statePayload?.location_mapped_with?.toLowerCase()
                      )}
                      onChange={e => {
                        setStatePayload(prev => ({
                          ...prev,
                          location_mapped_with: "city",
                        }));
                      }}
                    />

                    <Form.Check
                      type="radio"
                      id="option2"
                      name="location_mapped_with"
                      value="franchise"
                      label="Franchise"
                      checked={["franchise"].includes(
                        statePayload?.location_mapped_with?.toLowerCase()
                      )}
                      onChange={e => {
                        setStatePayload(prev => ({
                          ...prev,
                          location_mapped_with: "franchise",
                        }));
                      }}
                    />
                  </Form.Group>

                  {["franchise"].includes(
                    statePayload?.location_mapped_with?.toLowerCase()
                  ) ? (
                    <>
                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          Franchise<span class="text-danger">*</span>
                        </Form.Label>
                        <div className="selectoption">
                          <Select
                            options={FranchiseList}
                            value={FranchiseList?.find(
                              f => f?.id === statePayload?.franchise_id
                            )}
                            onChange={e => {
                              let locationList = e?.locationList || [];
                              setAllFranchiseLocations(locationList);
                              setSelectedFranchiseLocations([]);

                              setStatePayload(prev => ({
                                ...prev,
                                franchise_id: e?.value,
                                franchise_location_id: [],
                              }));
                            }}
                          />
                        </div>
                        {errors?.franchise_id && (
                          <p className="text-danger">
                            {" "}
                            {errors?.franchise_id}{" "}
                          </p>
                        )}
                      </Form.Group>

                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          Location
                        </Form.Label>
                        <div className="selectoption">
                          <Select
                            isMulti
                            options={extendedFranchiseLocationOptions}
                            value={selectedFranchiseLocations}
                            onChange={handleChangeFranchiseLocation}
                          />
                        </div>
                      </Form.Group>
                    </>
                  ) : (
                    <>
                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          City<span class="text-danger">*</span>
                        </Form.Label>
                        <div className="selectoption">
                          <Select
                            isMulti
                            options={extendedCityOptions}
                            value={selectedCities}
                            onChange={handleChangeCity}
                          />
                        </div>
                        {errors?.city_id && (
                          <p className="text-danger"> {errors?.city_id} </p>
                        )}
                      </Form.Group>

                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          Location
                        </Form.Label>
                        <div className="selectoption">
                          <Select
                            isMulti
                            options={extendedCityLocationOptions}
                            value={selectedCityLocations}
                            onChange={handleChangeCityLocation}
                            formatGroupLabel={data => (
                              <>
                                <div className="d-flex align-items-center justify-content-between">
                                  <span>{data?.label}</span>

                                  <span className="border rounded-circle text-center p-2 pt-1 pb-1 bg-secondary text-light">
                                    {data?.options?.length || 0}
                                  </span>
                                </div>
                              </>
                            )}
                          />
                        </div>
                      </Form.Group>
                    </>
                  )}
                </Row>
              </Col>

              <Form.Group className="col-md-12 mb-3 floating-label position-relative mt-2 required-skill-card">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <Form.Label className="mb-0">
                      Job Description<span class="text-danger">*</span>
                    </Form.Label>
                  </div>
                  <div className="job-desc-btn">
                    <Button
                      color="success"
                      className="px-2 py-1"
                      onClick={e => {
                        e.preventDefault();
                        handleContentGeneration();
                      }}
                      disabled={contentLoading}
                    >
                      {contentLoading ? (
                        <Spinner className="mx-2" size="sm" />
                      ) : null}
                      <img src="../img/chatgpt.svg" alt="" />
                      AI Generate
                    </Button>

                    <div className="job-chat-dec">
                      <p>
                        AI Generated Content <br />
                        <small>*Powered by Bard AI</small>
                      </p>
                    </div>
                  </div>
                </div>

                <ReactQuill
                  className="comment-card"
                  style={{ height: "200px" }}
                  placeholder="Job Description"
                  name="description"
                  value={statePayload?.description}
                  onChange={content => {
                    setStatePayload(prevState => ({
                      ...prevState,
                      ["description"]: content,
                    }));
                  }}
                  readOnly={contentLoading}
                />
                {errors?.description && (
                  <p className="text-danger mt-5"> {errors?.description} </p>
                )}
              </Form.Group>

              <Form.Group className="col-md-12 mb-3 floating-label mt-5  roundlist-post">
                <Form.Label className="float-label mb-0">
                  Round List<span class="text-danger">*</span>
                </Form.Label>
                <div className="mb-2">
                  <small>
                    *Please be aware that this field cannot be modified later.
                  </small>
                </div>
                <div className="d-flex justify-content around roud-call">
                  <div className="col-lg-6 col-sm-12">
                    <span>Available Rounds</span>
                    <div className="d-flex flex-wrap gap-2 roundlist pt-1 mr-4 flex-column">
                      {roundList?.map(item => (
                        <div
                          style={{
                            border: "1px solid lightgray",
                            padding: "8px",
                          }}
                          className="font-size-16 d-flex justify-content-between align-items-center"
                          key={item?.label}
                        >
                          <div>
                            {item?.label} [{item?.type}]
                          </div>
                          <FontAwesomeIcon
                            className="mx-2"
                            icon={faArrowAltCircleRight}
                            role="button"
                            onClick={() => handleAddRound(item)}
                            title="Add Round"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 px-2">
                    <span>Selected Rounds</span>
                    <ReactSortable
                      list={selectedRounds}
                      setList={setSelectedRounds}
                      className="pt-1 special-rounds-sa"
                    >
                      {selectedRounds?.map((item, index) => (
                        <>
                          <div
                            style={{
                              border: "1px solid lightgray",
                              padding: "8px",
                            }}
                            className="font-size-16 d-flex justify-content-between mb-2 align-items-center light-special-round"
                            key={item?.label}
                          >
                            <p>{`${index + 1}. ${item?.label} [${
                              item?.type
                            }]`}</p>
                            <div className="interview-card">
                              {item?.type === "Interview" && (
                                <>
                                  <div className="select-drop">
                                    <Select
                                      options={interviewerList}
                                      value={interviewerList?.find(
                                        val =>
                                          val?.value === item?.interviewer_id
                                      )}
                                      onChange={e => {
                                        handleSelectInterviewer(e, index);
                                      }}
                                      placeholder="Select Interviewer"
                                    />
                                  </div>
                                  <div className="select-drop">
                                    <Select
                                      options={interviewTypes}
                                      value={interviewTypes?.find(
                                        val => val?.value === item?.meeting_type
                                      )}
                                      onChange={e => {
                                        handleSelectInterviewType(e, index);
                                      }}
                                      placeholder="Select Type"
                                    />
                                  </div>
                                </>
                              )}
                              {item?.type === "Test" && (
                                <>
                                  <div className="select-drop">
                                    <Form.Control
                                      type="number"
                                      placeholder="Enter Passing Threshold"
                                      name="min_salary"
                                      value={item?.score_threshold}
                                      onChange={e => {
                                        handleScoreThreshold(
                                          e.target.value,
                                          index
                                        );
                                      }}
                                    />
                                  </div>
                                </>
                              )}
                              <div className="d-flex gap-3  select-drop deleteico">
                                <FontAwesomeIcon
                                  className="text-danger"
                                  icon={faTrash}
                                  onClick={() => handleRemoveRound(item)}
                                  role="button"
                                  title="Remove Round"
                                />
                              </div>
                            </div>
                            {item?.alias === "pre-assessment" && (
                              <>
                                <FontAwesomeIcon
                                  icon={faExclamation}
                                  id="my-tooltip-1"
                                />
                                <Tooltip
                                  anchorSelect="#my-tooltip-1"
                                  place="bottom"
                                  content="This Round will not be considered as a Main Round."
                                />
                              </>
                            )}
                          </div>
                        </>
                      ))}
                    </ReactSortable>
                    {selectedRounds?.length === 0 ? (
                      <small>No Rounds Selected</small>
                    ) : (
                      <small>
                        Note: You can drag and drop the rounds to alter the
                        order.
                      </small>
                    )}
                  </div>
                </div>
                {errors?.roundList && (
                  <p className="text-danger"> {errors?.roundList} </p>
                )}
              </Form.Group>

              <Form.Group className="col-md-12 col-lg-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  Budget Range<span class="text-danger">*</span>
                </Form.Label>
                <div className="d-flex gap-2 label-cardssrange">
                  <div className="w-100">
                    <div className="d-flex align-items-center budget-range">
                      <Form.Control
                        type="number"
                        placeholder="Enter Min. Budget"
                        name="min_salary"
                        value={statePayload?.min_salary}
                        onChange={handleInput}
                      />
                      <span className="font-size-16">
                        {companyCurrency?.symbol || ""}
                      </span>
                    </div>
                    {errors?.min_salary && (
                      <p className="text-danger"> {errors?.min_salary} </p>
                    )}
                  </div>
                  <div className="w-100">
                    <div className="d-flex align-items-center  budget-range">
                      <Form.Control
                        type="number"
                        placeholder="Enter Max. Budget"
                        name="max_salary"
                        value={statePayload?.max_salary}
                        onChange={handleInput}
                      />
                      <span className="font-size-16">
                        {companyCurrency?.symbol || ""}
                      </span>
                    </div>
                    {errors?.max_salary && (
                      <p className="text-danger"> {errors?.max_salary} </p>
                    )}
                  </div>
                </div>
              </Form.Group>

              {/* <Form.Group className="col-md-6 mb-3 floating-label mt-5">
            <Form.Label className="float-label">Pst Job On LinkedIn</Form.Label>
                      <div className="form-check btn-checkbox linkedin-sec">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value="1"
                          id="linkedinpost"
                          checked={
                            statePayload?.post_on_linkedIn ? true : false
                         }
                        onChange={() => {
                          setStatePayload((prevState) => ({
                            ...prevState,
                            post_on_linkedIn:
                              !statePayload?.post_on_linkedIn,
                          }));
                        }}
                        />
                        <label
                          className="form-check-label"
                          for="linkedinpost"
                        >
                         Yes
                        </label>
                        
                      </div>
                    </Form.Group>*/}

              <Form.Group className="col-md-6 col-lg-3 mb-3 floating-label">
                <div className="flot-label-section">
                  <Form.Label className="float-label">
                    Min Relevancy Score %<span class="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Min Relevancy Score %"
                    name="relevance_score"
                    value={statePayload?.relevance_score}
                    onChange={handleInput}
                  />
                  {errors?.relevance_score && (
                    <p className="text-danger"> {errors?.relevance_score} </p>
                  )}
                </div>
              </Form.Group>

              <Form.Group className="col-md-6 col-lg-3 mb-3 floating-label">
                <div className="flot-label-section">
                  <Form.Label className="float-label">
                    Min Behavioural Score %<span class="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Min Behavioural Score %"
                    name="video_analysis_score"
                    value={statePayload?.video_analysis_score}
                    onChange={handleInput}
                  />
                  {errors?.video_analysis_score && (
                    <p className="text-danger  mb-0 pb-1">
                      {" "}
                      {errors?.video_analysis_score}{" "}
                    </p>
                  )}
                </div>
              </Form.Group>

              <Form.Group className="col-md-2 floating-label status-checkbox">
                <Form.Label className="float-label">
                  Status<span class="text-danger">*</span>
                </Form.Label>
                <div className="mt-2">
                  <label className="switch" htmlFor={"tableSwitch"}>
                    <input
                      type="checkbox"
                      id={`tableSwitch`}
                      onClick={e => {
                        let value = e.target.checked ? "1" : "0";
                        handleInput({
                          target: { name: "status", value: value },
                        });
                      }}
                      defaultChecked={statePayload?.status === "1"}
                    />
                    <div className="slider round"></div>
                  </label>
                </div>

                {/* <Form.Check
                type="checkbox"
                name="status"
                className="font-size-20 mx-2"
                checked={statePayload?.status === "1"}
                onChange={(e) => {
                  let value = e.target.checked ? "1" : "0"
                  handleInput({ target: { name: 'status', value: value } })
                }}
              /> */}

                {errors?.status && (
                  <p className="text-danger"> {errors?.status} </p>
                )}
              </Form.Group>
              <Form.Group className="col-md-2 floating-label status-checkbox">
                <div className="licace-app">
                  <Form.Label className="float-label">
                    License Applicable<span class="text-danger">*</span>
                  </Form.Label>
                  <div className="mt-2">
                    <label className="switch" htmlFor={"licenseSwitch"}>
                      <input
                        type="checkbox"
                        id={`licenseSwitch`}
                        onClick={e => {
                          let value = e.target.checked ? "1" : "0";
                          handleInput({
                            target: { name: "license", value: value },
                          });
                        }}
                        defaultChecked={statePayload?.license === "1"}
                      />
                      <div className="slider round"></div>
                    </label>
                  </div>

                  {/* <Form.Check
                type="checkbox"
                name="status"
                className="font-size-20 mx-2"
                checked={statePayload?.status === "1"}
                onChange={(e) => {
                  let value = e.target.checked ? "1" : "0"
                  handleInput({ target: { name: 'status', value: value } })
                }}
              /> */}

                  {errors?.license && (
                    <p className="text-danger"> {errors?.license} </p>
                  )}
                </div>
              </Form.Group>
              <Form.Group className="col-md-12 mb-3 floating-label  VideoAnalysisQuestion  mt-2">
                <Form.Label className="float-label">
                  Video Analysis Question<span class="text-danger">*</span>
                </Form.Label>

                <ReactQuill
                  className="comment-card"
                  style={{ height: "150px" }}
                  name="video_analysis_ques"
                  placeholder="Video Analysis Questions"
                  value={statePayload?.video_analysis_ques}
                  onChange={content => {
                    setStatePayload(prevState => ({
                      ...prevState,
                      ["video_analysis_ques"]: content,
                    }));
                  }}
                />

                {errors?.video_analysis_ques && (
                  <p className="text-danger mt-5  mb-0 pb-1">
                    {" "}
                    {errors?.video_analysis_ques}{" "}
                  </p>
                )}
              </Form.Group>
            </Row>
            <br />
            <Form.Group className="cta editjob-space text-center d-flex gap-2 justify-content-start mt-4">
              <Link
                to="/Job-list"
                style={{ marginLeft: "5px" }}
                className="btn btn-secondary"
              >
                Cancel
              </Link>
              <ButtonLoader
                title="Save Details"
                variant="primary"
                style={{ marginLeft: "5px" }}
                type="submit"
                loading={isLoading}
                message={"Saving"}
                onClick={e => {
                  handleSubmit(e);
                }}
              />
            </Form.Group>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CreateJob;
